<template>
  <div>
    <div class="row p-3">
      <div class="col">
        <label class="resumo-show_label">Nome Cônjuge 1</label>
        <div class="resumo-show_sublabel">
          {{ propHabilitacao.registro.pessoas[0].nome_antigo || 'Nome não informado' }}
        </div>
      </div>
      <div class="col">
        <label class="resumo-show_label">Nome Cônjuge 2</label>
        <div class="resumo-show_sublabel">
          {{ propHabilitacao.registro.pessoas[1].nome_antigo || 'Nome não informado' }}
        </div>
      </div>
      <div class="col-5">
        <span id="converter-casamento"
              class="d-inline-block">
          <button v-if="propHabilitacao.gerar_autuacao && propHabilitacao.tipo_casamento !== EDITAL_OUTRA_SERVENTIA && propHabilitacao.tipo_casamento !== CASAMENTO_CIVIL_OUTRO_CARTORIO"
                  class="btn btn-primary btn-sm"
                  :disabled="propHabilitacao.casamento"
                  @click="converter()">
            Converter em Registro de Casamento
          </button>
        </span>
        <b-tooltip v-if="propHabilitacao.casamento && propHabilitacao.gerar_autuacao"
                   target="converter-casamento">
          Esta habilitação já foi convertida em registro de casamento.
        </b-tooltip>
        <button v-if="!propHabilitacao.gerar_autuacao"
                class="btn btn-outline-primary btn-sm"
                @click="gerarAutuacao()">
          Gerar autuação
        </button>
        <b-link class="btn btn-primary btn-sm ml-2"
                :to="{ name: 'editar_habilitacao_casamento', params: { id: $route.params.id, propHabilitacao: propHabilitacao } }">
          Editar
        </b-link>
      </div>
    </div>

    <div class="row">
      <div class="col">
        <sub-header-grey class="py-2">
          <label class="label">Dados do Casamento</label>
        </sub-header-grey>
        <div class="row p-3">
          <div v-if="propHabilitacao.tipo_casamento !== EDITAL_OUTRA_SERVENTIA"
               class="col-2">
            <label class="resumo-show_label">Data do Casamento</label>
            <div v-if="propHabilitacao.data_casamento"
                 class="resumo-show_sublabel">
              {{ propHabilitacao.data_casamento | date }}
            </div>
            <div v-else
                 class="resumo-show_sublabel">
              {{ 'Data não Informado' }}
            </div>
          </div>
          <div v-if="propHabilitacao.tipo_casamento !== EDITAL_OUTRA_SERVENTIA"
               class="col-2">
            <label class="resumo-show_label">Hora do Casamento</label>
            <div class="resumo-show_sublabel">
              {{ propHabilitacao.hora_casamento || 'Hora não Informado' }}
            </div>
          </div>
          <div class="col">
            <label class="resumo-show_label">Tipo de Casamento</label>
            <div class="resumo-show_sublabel">
              {{ propHabilitacao.tipo_casamento || 'Tipo de Casamento não Informado' }}
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col">
        <sub-header-grey class="py-2">
          <label class="label">Local de Casamento</label>
        </sub-header-grey>
        <div class="row p-3">
          <div class="col">
            <label class="resumo-show_label">Casamento em cartório</label>
            <!-- regra de identificação irá ser implementada ainda -->
            <div class="resumo-show_sublabel">
              {{ !!propHabilitacao.casamento_em_cartorio ? 'Sim': 'Não' }}
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col">
        <sub-header-grey class="py-2">
          <label class="label">Publicação de edital</label>
        </sub-header-grey>
        <div v-if="!propHabilitacao.data_publicacao"
             class="row p-3">
          <div class="col">
            <EProclamas :prop-registro="propHabilitacao"
                        :prop-data-publicacao="data_publicacao"
                        @reload="$emit('reload')" />
          </div>
        </div>
        <div v-else
             class="row p-3">
          <div v-if="propHabilitacao.publicacao === 'NAO_PUBLICAR'"
               class="col resumo-show_sublabel">
            Dispensada a publicação de edital.
          </div>
          <div v-else
               class="col resumo-show_sublabel">
            Publicado no jornal {{ propHabilitacao.publicacao }} em {{ propHabilitacao.data_publicacao | date }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  /* components */
  import SubHeaderGrey from "@/components/SofiaRei/Headers/SubHeaderGrey"
  import EProclamas from '@/components/SofiaRei/EProclamas/eProclamas'

  /* constants */
  import { EDITAL_OUTRA_SERVENTIA, CASAMENTO_CIVIL_OUTRO_CARTORIO } from "@/constants/casamento/tipos"

  export default {
    name: "ResumoHabilitacaoCasamentoDetalhes",
    components: {
      SubHeaderGrey,
      EProclamas
    },
    props: {
      propHabilitacao: {
        type: Object,
        default: () => {
          return {}
        }
      }
    },
    data () {
      return {
        data_publicacao: null,
        EDITAL_OUTRA_SERVENTIA,
        CASAMENTO_CIVIL_OUTRO_CARTORIO
      }
    },
    watch: {
      propHabilitacao () {
        this.getDataPublicacao()
      }
    },
    mounted () {
      this.getDataPublicacao()
    },
    methods: {
      converter () {
        if (!!this.propHabilitacao.casamento) {
          window.displayMessage('question', 'Casamento já registrado!', 'Ir para o casamento criado?', { cancelButtonText: "Não", confirmButtonText: "Sim" })
            .then(res => {
              if (res.value) {
                this.$router.push({name: 'resumo_casamento', params: {id: this.propHabilitacao.casamento.casamento_id }})
              }
            })
          return
        }

        this.$router.push({name: 'registro_casamento', params: {id: 'novo', propHabilitacao: this.propHabilitacao}})
      },
      getDataPublicacao () {
        const tarefaProclamas = this.propHabilitacao.registro.tarefas.find(tarefa => {
          return tarefa.tipo === 'HABILITACAO_CASAMENTO' && tarefa.acao === 'PUBLICAR_PROCLAMAS'
        })

        if (tarefaProclamas) {
          this.data_publicacao = tarefaProclamas.data_cumprimento
        }
      },
      gerarAutuacao () {
        this.$emit('onGerarAutuacao')
      }
    }
  }
</script>

<style>
  .data-eproclamas {
    font-family: Roboto;
    font-size: 12px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.36;
    letter-spacing: normal;
    text-align: left;
    color: #373a3c;
  }
</style>
